import { Box, Button, Container, Tooltip, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useNavigate } from 'react-router-dom';

import RunSummary from './summary/RunSummary';

export default function ActiveRunsSummaryPage() {
  const navigate = useNavigate();

  return (
    <Container maxWidth="xl" sx={{ py: 3, pt: 0 }}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexDirection={{ xs: 'column', sm: 'row' }}
        gap={1.5}
        mb={2}
      >
        <Box>
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="h5" sx={{ fontWeight: 800 }}>
              Runs Summary
            </Typography>
            <Tooltip title="Summary is loaded from backend run history matching selected filters.">
              <InfoOutlinedIcon sx={{ color: 'text.secondary', fontSize: 18 }} />
            </Tooltip>
          </Box>
          <Typography variant="body2" color="text.secondary">
            Backend run history matching selected filters
          </Typography>
        </Box>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/active-runs')}
          sx={{ textTransform: 'none', fontWeight: 700 }}
        >
          Back to Active Runs
        </Button>
      </Box>
      <RunSummary />
    </Container>
  );
}
